<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title"> 휴/복직신청 </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in list" :key="i" class="gntType-item">
            <v-list-item-content @click="selectMenu(item)">
              <v-list-item-title>
                <span class="time">{{ item.codeNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
//import routerNames from '@/const/routerConstants';
import { getLeaAbsAppApplCdList, getLeaAbsAppMap, getLeaAbsAppStatusCd } from '@/api/workStatus';

export default {
  data: () => ({
    list: [],
  }),

  computed: {},

  methods: {
    /* 신청서 선택 */
    async selectMenu(item) {
      this.$store.commit('SET_CODE', item.code);
      this.$store.commit('SET_APPL_CD', item.applCd);
      this.$store.commit('SET_TIM_APPL_SEQ', null);

      const applParam = {
        applCd: item.applCd,
        searchApplCd: item.applCd,
      };

      let response = await getLeaAbsAppMap(applParam);
      //재직상태
		  let statusdata = await getLeaAbsAppStatusCd(applParam);

		  let statusCd = statusdata.data.data.statusCd;

      if(statusCd === 'RA'){//퇴직
        alert("퇴직 직원은 신청할 수 없습니다.");
        return;
      }else{
        if(response != null && response.data.data != null) {
          if(response.data.data.ordTypeCd == '0070'){//복직
            if(statusCd != 'CA'){
              alert("휴직 직원인 경우만 복직신청할 수 있습니다.");
              return;
            }
          }
        }
      }

      let routerName = await this.$store.dispatch(
        'ELA/FETCH_MENU_ACTION',
        applParam,
      );

      this.$router.push(routerName);
    },
  },

  async mounted() {
    let params = {};

    let response = await getLeaAbsAppApplCdList(params);
    this.list = response.data.data;

    this.$store.commit('SET_PER_DAY', 0);
  },
};
</script>

<style></style>
